import { AxiosResponse } from 'axios';

import Resolver from 'src/common/Resolver';
import useParticipantsStore from 'src/stores/participantsStore';
import useRegistrationsStore from 'src/stores/registrationsStore';
import UserParticipants from './UserParticipants';

const UserParticipantsResolver = () => {
  const {
    fetchMyParticipants: doFetchMyParticipants,
    fetchMyPendingClaims: doFetchMyPendingClaims,
  } = useParticipantsStore(participantsState => participantsState);
  const {
    fetchMyRegistrations: doFetchMyRegistrations,
  } = useRegistrationsStore();

  const loadDependencies = () => {
    const deps: Array<Promise<void | AxiosResponse<unknown>>> = [
      doFetchMyParticipants(),
      doFetchMyPendingClaims(),
      doFetchMyRegistrations(),
    ];

    return Promise.all(deps);
  };

  return <Resolver resolve={loadDependencies} successComponent={UserParticipants} />;
};

export default UserParticipantsResolver;

